import React, { Component } from 'react';
import { Route, Redirect, withRouter } from 'react-router';
import { Tabs } from 'antd';
import Daily from './daily/daily';
import Weekly from './weekly/weekly';
import AllTime from './allTime/allTime';
import Spinner from '../../../spinner/spinner';
import { activeSubPath } from '../../../../utilities/routes';
import { graphql } from 'react-apollo';
import { getRevivalWeeks } from '../queries/queries';
import StatsManagement from './statsManagement';
import { resetStats } from './../mutations/resetStats';

class ChurchPage extends Component {
  onTabChange = (key) => this.props.history.push(key);
  tabPath = (name) => `${this.props.match.url}/${name}`;

  render() {
    if (this.props.revivalWeeks.loading) {
      return <Spinner />;
    }

    const revivalWeeks = this.props.revivalWeeks.church.revival.weeks;

    return (
      <div>
        <Route exact path={`${this.props.match.url}`} render={() => <Redirect to={`${this.tabPath('daily')}`} />} />

        <StatsManagement {...this.props} churchId={this.props.selectedChurch.id} />

        <Tabs className="statistic-types-tabs" type="line" size="small" animated={true}
              activeKey={`${activeSubPath(this.props.location.pathname, 'church')}`} onChange={this.onTabChange}>
          <Tabs.TabPane tab="Daily" key={`${this.tabPath('daily')}`}>
            <Route path={`${this.tabPath('daily')}`} render={() => <Daily {...this.props} />} />
          </Tabs.TabPane>
          <Tabs.TabPane tab="Weekly" key={`${this.tabPath('weekly')}`}>
            <Route path={`${this.tabPath('weekly')}`} render={() => <Weekly {...this.props} revivalWeeks={revivalWeeks} />} />
          </Tabs.TabPane>
          <Tabs.TabPane tab="All Time" key={`${this.tabPath('allTime')}`}>
            <Route path={`${this.tabPath('allTime')}`} render={() => <AllTime {...this.props} />} />
          </Tabs.TabPane>
        </Tabs>
      </div>
    );
  }
}

export default withRouter(
  graphql(getRevivalWeeks, {
    options: ({ selectedChurch }) => ({ variables: { church_id: selectedChurch.id } }),
    name: 'revivalWeeks'
  })(ChurchPage)
);



// WEBPACK FOOTER //
// ./src/components/pages/statistics/church/churchPage.js